var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgServiceNow = function SvgServiceNow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#service-now_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#81B5A1",
    fillRule: "evenodd",
    d: "M10.06 1.035A10.083 10.083 0 0 0 3.11 18.401a1.98 1.98 0 0 0 2.583.134 7.2 7.2 0 0 1 8.576 0 1.99 1.99 0 0 0 2.622-.134 10.084 10.084 0 0 0-6.83-17.366m-.055 15.086a4.885 4.885 0 0 1-5.042-5.008 5.014 5.014 0 1 1 10.022 0 4.88 4.88 0 0 1-5.008 5.008",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "service-now_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgServiceNow;